module.exports = __webpack_public_path__ + "static/img/特色融资bg.501e494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/特色融资bg.png
// module id = pg3r
// module chunks = 1